import { KeywordService } from "@/services/admin-services";
import { Keyword } from "@/services/admin-services/models/Keyword";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import { useState } from "react";

interface ConfirmDeleteDialogProps {
    open: boolean;
    element: string;
    keyword: Keyword;
    code: string;
    onCancel: () => void;
    onDelete: (success: boolean) => void;
    onUpdate: (keyword: Keyword) => void;
}

const ConfirmDeleteDialog = ({
    open,
    element,
    keyword,
    code,
    onCancel,
    onDelete,
    onUpdate,
}: ConfirmDeleteDialogProps) => {
    const [isSaving, setIsSaving] = useState<boolean>(false);

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

    const keywordService = new KeywordService("int");

    const onConfirmDelete = () => {
        setIsSaving(true);

        const updatedKeyword = { ...keyword };
        updatedKeyword.labels = updatedKeyword.labels.filter((x) => x.languageCode !== code);

        if (updatedKeyword.labels.length === 0) {
            keywordService.delete(element, updatedKeyword.id).then((success) => {
                setIsSaving(false);
                onDelete(success);
            });
        } else {
            keywordService.update(element, updatedKeyword.id, updatedKeyword).then((keyword) => {
                setIsSaving(false);
                onUpdate(keyword);
            });
        }
    };

    return (
        <Dialog open={open} onClose={onCancel} fullWidth maxWidth={"sm"} fullScreen={fullScreen}>
            <DialogTitle>Delete keyword</DialogTitle>
            <DialogContent dividers>
                <DialogContentText>
                    Are you sure you wish to delete this keyword? You can not undo this action!
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel} disabled={isSaving}>
                    Cancel
                </Button>
                <Button variant="contained" color={"error"} onClick={onConfirmDelete} disabled={isSaving}>
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDeleteDialog;
